import React, { Component } from 'react';
import { connect } from 'react-redux';
import actions from '@/redux/action';
import { withTranslation } from 'react-i18next';
import DynamicPhotoWork from './children/DynamicPhotoWork';
import DownloadPage from './children/DownloadPage';
import '@/assets/dynamicPhoto.less';

class DynamicPhoto extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    window.addEventListener('showTitle', () => {
      const hideDom = document.querySelectorAll('#hideTitle');
      hideDom.forEach((item) => {
        item.style.display = 'block';
      });
    });
  }

  render() {
    const { t } = this.props;
    return (
      <div className='DynamicPhoto container'>
        <h1 id='hideTitle'>{t('Animate old photos')}</h1>
        <p id='hideTitle'>
          {t(
            'Animate faces in your photos with AI technology, create vivid videos.'
          )}
        </p>

        <DynamicPhotoWork />
        {/* <Exceed2M /> */}
      </div>
    );
  }
}

const mapStateToPropos = (state) => ({
  currFile: state.files.currFile,
  toGifObj: state.work.toGifObj,
});

const mapDispatchToProps = (dispatch) => ({
  onToGifObjChange: (toGifObj) => dispatch(actions.onToGifObjChange(toGifObj)),
});

export default connect(
  mapStateToPropos,
  mapDispatchToProps
)(withTranslation(['dynamicPhoto'])(DynamicPhoto));
